const files = require.context('../pages', true, /routes\/index.tsx$/);

const pageRoutes: any[] = [];

files.keys().forEach((file: string) => {
  pageRoutes.push(...files(file).routes.filter((v: any) => v.enable));
});
pageRoutes.sort((a, b) => {
  const aOrder = a.order || 0;
  const bOrder = b.order || 0;
  return aOrder - bOrder;
});

export { pageRoutes };
